export const DURATION = 200;

const TRANSITION_CLASSES = [
  'step-transition',
  'step-transition-none',
  'step-fade-out',
  'step-slide-left',
  'step-slide-right',
  'step-visible',
];

function clearClasses(el) {
  el.classList.remove(...TRANSITION_CLASSES);
}

// Slide-transition between two elements.
// direction: 'forward' slides left-to-right, 'backward' right-to-left.
// Returns a timeout ID for cleanup.
export function transitionSteps(outEl, inEl, direction = 'forward') {
  clearClasses(outEl);
  outEl.classList.add(
    'step-transition',
    'step-fade-out',
    direction === 'forward' ? 'step-slide-left' : 'step-slide-right'
  );

  return setTimeout(() => {
    outEl.classList.add('d-none');
    clearClasses(outEl);

    clearClasses(inEl);
    inEl.classList.add(
      'step-transition-none',
      'step-fade-out',
      direction === 'forward' ? 'step-slide-right' : 'step-slide-left'
    );
    inEl.classList.remove('d-none');

    inEl.getBoundingClientRect();

    inEl.classList.remove('step-transition-none');
    inEl.classList.add('step-transition', 'step-visible');
    inEl.classList.remove('step-fade-out', 'step-slide-left', 'step-slide-right');
  }, DURATION);
}

// Promise-based version for async flows.
export function transitionStepsAsync(outEl, inEl, direction = 'forward') {
  return new Promise((resolve) => {
    transitionSteps(outEl, inEl, direction);

    let resolved = false;
    const done = () => {
      if (resolved) return;
      resolved = true;
      inEl.removeEventListener('transitionend', done);
      resolve();
    };

    inEl.addEventListener('transitionend', done);
    setTimeout(done, DURATION * 2);
  });
}
